<template>
    <div class="range range--tooltip">
        <span class="d-block">MPG for Fuel Illustration
            <VDropdown :disabled="!tooltip">
              <button class="tooltip-button"><i class="icon-info-solid"/></button>
              <template #popper>
                <h3>MPG Slider</h3>
                <p>The MPG slider allows you to amend the value based on your driving style, this will vary your fuel costs and help you view the real-world cost implication. You can return to the manufacturers published value by selecting the reset button at the end of the slider. We recommend researching the real world mpg values for this vehicle and your regular journeys and considering a range of MPGs.</p>
              </template>
            </VDropdown>
        </span>
        <template v-if="defaultMpg !== null">
            <Slider
                v-bind="rangeConfig"
                v-model="rangeConfig.value"
                @change="calculateMpg(quote.quote, $event)"
            />

<!--            <v-nus :config="rangeConfig" :value="[currentMPG]" @change="calculateMpg(quote.quote, $event)"></v-nus>-->
            <button class="reset" @click="quote.quote.taxCalculations.mpg = resetMPG(quote.quote)"></button>
        </template>
        <template v-else>
            <loading-icon></loading-icon>
        </template>
    </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';
import LoadingIcon from "../loading-icon";
import Slider from '@vueform/slider'

export default {
    name: "mpg-slider",
    components: {
      LoadingIcon,
      Slider
    },
    props: [
        "quote",
        "defaultMpg"
    ],
    data() {
        return {
            rangeConfig: {
                step: 0.1,
                min: 1,
                max: 200,
                tooltips: false,
                value: [1, 200],
            },
            tooltip: true
        }
    },
    watch: {
        defaultMpg(value) {
            this.resetMPG(this.quote);
        },
    },
    methods: {
        resetMPG(quote) {
            this.quote.taxCalculations = this.calculateMpg(quote, this.defaultMpg);
            return this.defaultMpg;
        },
        calculateMpg(quote, value) {
            EventBus.$emit('loadingTitle', 'Calculating MPG');
            EventBus.$emit('loading', true);
            this.$http.post('/api/quotation', {
                method: 'GET',
                endpoint: `quotes/${quote.quoteID}/taxCalculations/Latest`,
                uri_params: {
                    mpgOverride: value,
                    forceRecalculate: 'true'
                }
            })
                .then(response => {
                    EventBus.$emit('loading', false);
                    quote.taxCalculations = response.data.data;
                    this.$emit('updatedCalculations', quote.taxCalculations)
                    this.quote.taxCalculations = quote.taxCalculations;
                });
            Vue.set(this.quote, 'taxCalculations', quote.taxCalculations);
            return quote.taxCalculations;
        },
    },
    computed: {
        currentMPG() {
            if (!this.quote.taxCalculations || !this.quote.taxCalculations.mpg) {
                return this.defaultMpg;
            } else {
                return this.quote.taxCalculations.mpg;
            }

        }
    }
}
</script>

<style scoped>

</style>
